var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Users List")]),_c('ul',_vm._l((_vm.Users),function(user){return _c('li',{key:user.uid},[_vm._v(_vm._s(((user.firstName) + " " + (user.lastName))))])}),0),_c('p',[_vm._v(_vm._s(_vm.currentUser))])])}
var staticRenderFns = []

export { render, staticRenderFns }